import request from '@/router/axios';


//储能总收益、节约减排指标
export const searchSolarAndEnergyStorageIncomeAndSaveEmissions = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchSolarAndEnergyStorageIncomeAndSaveEmissions',
    method: 'post',
    data: data
  })
}

//光伏总容量与储能总容量
export const searchSolarAndEnergyStorageVolume = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchSolarAndEnergyStorageVolume',
    method: 'post',
    data: data
  })
}

//储能统计
export const searchEnergyStorageStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchEnergyStorageStatistics',
    method: 'post',
    data: data
  })
}
//光伏统计
export const searchSolarStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchSolarStatistics',
    method: 'post',
    data: data
  })
}
//市电统计
export const searchElectricSupplyStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchElectricSupplyStatistics',
    method: 'post',
    data: data
  })
}
//收益统计
export const searchEnergyStorageIncomeStatisticsColumnChart = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchEnergyStorageIncomeStatisticsColumnChart',
    method: 'post',
    data: data
  })
}
//能耗统计
export const searchEnergyConsumptionStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchEnergyConsumptionStatistics',
    method: 'post',
    data: data
  })
}
//各场景实时功率
export const searchRealTimePower = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchRealTimePower',
    method: 'post',
    data: data
  })
}

//项目页面-储能容量30172
export const searchEnergyStorageVolume = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchEnergyStorageVolume',
    method: 'post',
    data: data
  })
}

//项目页面-日充放电柱状图30128
export const searchEnergyStorageChargeAndDischargeColumnChart = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchEnergyStorageChargeAndDischargeColumnChart',
    method: 'post',
    data: data
  })
}

//项目页面-市电功率曲线30173
export const searchElectricSupplyPowerCurves = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchElectricSupplyPowerCurves',
    method: 'post',
    data: data
  })
}
//智能用终端装机规模
export const statisticalCapacityByProject = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/statisticalCapacityByProject',
    method: 'post',
    data: data
  })
}
//项目下不包含SOC储能统计
export const energyStorageStatisticsExcludeSOC = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/energyStorageStatisticsExcludeSOC',
    method: 'post',
    data: data
  })
}

//项目下收益统计
export const projectEarningsStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/projectEarningsStatistics',
    method: 'post',
    data: data
  })
}
//项目下节能统计
export const projectEnergySaveStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/projectEnergySaveStatistics',
    method: 'post',
    data: data
  })
}
//项目下充电桩统计
export const chargingPileStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/chargingPileStatistics',
    method: 'post',
    data: data
  })
}
//查询面板和数据点
export const searchFixSimulationPanelData = (data) => {
  return request({
    url: '/svolt-ess-service/project/monitor/searchFixSimulationPanelData',
    method: 'post',
    params: data
  })
}

//项目下充放电效率
export const searchEnergyStorageChargeAndDischargeEfficiency = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchEnergyStorageChargeAndDischargeEfficiency',
    method: 'post',
    data: data
  })
}
//项目首页展示信息
export const searchProjectInfoForMain = (data) => {
  return request({
    url: '/svolt-ess-service/projectMain/searchProjectInfoForMain',
    method: 'post',
    data: data
  })
}
export default {
  searchSolarAndEnergyStorageIncomeAndSaveEmissions,
  searchSolarAndEnergyStorageVolume,
  searchEnergyStorageStatistics,
  searchSolarStatistics,
  searchElectricSupplyStatistics,
  searchEnergyStorageIncomeStatisticsColumnChart,
  searchEnergyConsumptionStatistics,
  searchRealTimePower,
  searchEnergyStorageVolume,
  searchEnergyStorageChargeAndDischargeColumnChart,
  searchElectricSupplyPowerCurves,
  statisticalCapacityByProject,
  energyStorageStatisticsExcludeSOC,
  projectEarningsStatistics,
  projectEnergySaveStatistics,
  chargingPileStatistics,
  searchFixSimulationPanelData,
  searchEnergyStorageChargeAndDischargeEfficiency,
  searchProjectInfoForMain
}



// WEBPACK FOOTER //
// ./src/api/svolt/project.js